export default class ImageFrame {
  constructor (element, args) {
    this.img = document.createElement('img')
    this.img.src = args.image ? args.image : ''

    let fragment = document.createDocumentFragment()
    fragment.appendChild(this.img)

    if (element) {
      element.appendChild(fragment)
    }
  }

  getImage () {
    return this.img.src
  }

  setImage (image) {
    this.img.src = image ? image : ''
  }

  getElement () {
    return this.img
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/ImageFrame.js